/** Numbered DEMO WALK — same 1–4 script as admin Live jobs + tech PWA. Shop Create is step 1. */

import { shopJobsSotHref, shopLiveJobsEntryHref, shopStatusFromSearch } from './jobsSurface';

function searchParams(search = '') {
    const raw = String(search).startsWith('?') ? String(search).slice(1) : String(search);
    return new URLSearchParams(raw);
}

/** DEMO WALK Assign via assignJob. Mint handoff unless a leftover Active fixture is already on. */
export function shopDemoWalkActiveHref(search = '') {
    if (searchParams(search).get('jobsSot') === 'handoff') {
        return shopJobsSotHref('handoff', search);
    }
    return shopJobsSotHref('handoff', search);
}

export const SHOP_DEMO_WALK_ORDER = ['seed', 'pending', 'assign', 'complete'];

export function shopDemoWalkSteps(search = '') {
    return [
        { id: 'seed', n: 1, label: 'Seed pending', detail: 'this Create (createShopJob)', href: null },
        { id: 'pending', n: 2, label: 'Open a Pending row', detail: '— admin Pending follows', href: shopLiveJobsEntryHref(search) },
        { id: 'assign', n: 3, label: 'Assign via assignJob', detail: '— this Active tab follows', href: shopDemoWalkActiveHref(search) },
        { id: 'complete', n: 4, label: 'Complete via completeJob', detail: '— admin Complete follows', href: null },
    ];
}

export function shopDemoWalkKeepNote() {
    return 'Same 1–4 script as admin Live jobs + tech PWA. Cross-surface E2E: shop createIntake / createShopJob → admin Pending → assignJob → this Active tab + PWA Active → completeJob. No hard-refresh thrash. Current-step fill stays through completeJob. After Complete, shop + admin + PWA stay on step 4. Open a Pending row uses the same Pending entry href as the Pending tab (shopLiveJobsEntryHref — admin scoreboardLiveJobsEntryHref contract). Leftover jobsSot=pending-seed / pending-handoff stay so entry is not Seed. Active / Complete jobsSot is dropped so Pending is not wearing handoff / complete-handoff. DEMO WALK Assign via assignJob mints jobsSot=handoff when there is no leftover Active fixture so the step paints a Demo Camry active row — not ACTIVE · EMPTY. jobsSot=pending-handoff paints this pending row (step 2). jobsSot=handoff paints Active (step 4). jobsSot=complete-handoff paints Complete (step 4). A jobsSot-only URL writes the matching ?status= chip so fill does not fall to Seed. Region switch colorado2 ↔ Test Region keeps ?status= and jobsSot — it is not Exit SoT. DEMO WALK rebinds to the named region (not preview-test-region). Admin Complete + PWA Complete follow the same fixture. Exit SoT drops jobsSot / createSot so Seed, pending-handoff, handoff, and complete-handoff re-enter clean. Only createShopJob / createIntake write pending. Only assignJob writes active. Only completeJob writes complete. Never ADAS.';
}

export function shopDemoWalkNote() {
    return 'Demo walk: 1. Seed pending on this Create (createShopJob)  2. Open a Pending row (admin Pending follows)  3. Assign via assignJob (this Active tab follows)  4. Complete via completeJob (this Complete tab + admin Complete + PWA Complete follow). Current-step fill stays through the handoff. After Complete, shop stays on step 4 with 1–3 done.';
}

export function shopDemoWalkCurrentStep(input = {}) {
    const fixture = input.sot || input.preview || '';
    if (fixture === 'complete-handoff' || fixture === 'handoff') return 'complete';
    if (fixture === 'pending-handoff' || fixture === 'pending') return 'pending';
    if (input.createSot === 'pending' || input.createPreview === 'pending') return 'pending';
    if (input.openTab === 3) return 'complete';
    const stored = (input.jobStatus || '').trim();
    if (stored === 'active' || stored === 'complete') return 'complete';
    if (stored === 'pending') return 'pending';
    if ((input.pendingCount || 0) > 0) return 'pending';
    if ((input.completeCount || 0) > 0) return 'complete';
    return 'seed';
}

export function shopDemoWalkStepState(id, current) {
    const index = SHOP_DEMO_WALK_ORDER.indexOf(id);
    const currentIndex = SHOP_DEMO_WALK_ORDER.indexOf(current);
    if (index === currentIndex) return 'current';
    if (index >= 0 && currentIndex >= 0 && index < currentIndex) return 'done';
    return 'todo';
}

export function shopDemoWalkStepClass(id, current) {
    const state = shopDemoWalkStepState(id, current);
    if (state === 'current') return 'is-current';
    if (state === 'done') return 'is-done';
    return undefined;
}

export function shopDemoWalkSotLinks(search = '') {
    return [
        { id: 'pendingHandoff', label: 'jobsSot pending-handoff', href: shopJobsSotHref('pending-handoff', search) },
        { id: 'handoff', label: 'jobsSot handoff', href: shopJobsSotHref('handoff', search) },
        { id: 'completeHandoff', label: 'jobsSot complete-handoff', href: shopJobsSotHref('complete-handoff', search) },
        { id: 'createPending', label: 'createSot pending', href: '/app/jobs?createSot=pending' },
    ];
}

/** Tab for a Hosting fixture or ?status= chip. Exit / unknown → Pending (1) so walk fill is not stuck on Complete. */
export function shopDemoWalkOpenTab(input = {}) {
    const status = input.status || shopStatusFromSearch(input.search);
    if (status === 'complete') return 3;
    if (status === 'active') return 2;
    if (status === 'pending') return 1;
    const fixture = input.sot || input.preview || '';
    if (fixture === 'complete-handoff') return 3;
    if (fixture === 'handoff') return 2;
    if (fixture === 'pending-handoff') return 1;
    return 1;
}

export function shopDemoWalkEyebrow(regionLabel) {
    const label = String(regionLabel || '').trim() || 'glass-shop';
    return `DEMO WALK · ${label}`;
}

/** Open Complete for complete-handoff unless the operator just clicked another tab. */
export function shouldOpenShopCompleteTab(input = {}) {
    if (input.fixture !== 'complete-handoff') return false;
    const tab = input.currentTab;
    return tab == null || tab === 3;
}

/** Open Active for handoff unless the operator just clicked another tab. */
export function shouldOpenShopActiveTab(input = {}) {
    if (input.fixture !== 'handoff') return false;
    const tab = input.currentTab;
    return tab == null || tab === 2;
}

export function shouldResetShopWalkResidue(input = {}) {
    return (input.previousSot || null) !== (input.nextSot || null)
        || (input.previousCreateSot || null) !== (input.nextCreateSot || null);
}

export function shopDemoWalkStampLine(stamp) {
    const value = (stamp || '').trim() || 'unknown';
    return `shop build ${value}`;
}

export function shopDemoWalkStampHint() {
    return 'Hard refresh if the walk looks stale · Cmd/Ctrl+Shift+R';
}
